import { render, staticRenderFns } from "./StockOpnameNew_Items.vue?vue&type=template&id=bbe019b6&"
import script from "./StockOpnameNew_Items.vue?vue&type=script&lang=js&"
export * from "./StockOpnameNew_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports